import React, { useState } from "react";
import Home from "./components/Home";
import Contact from "./components/Contact";
import "./App.css";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  const openContact = (e) => {
    e.preventDefault();
    setContactOpen(true);
    setMenuOpen(false);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="App">
      {/* ── Navbar ── */}
      <nav className="nav-main">
        <a href="/" className="nav-logo">
          <img src="/imagenes/logo.png" alt="APP DGM DESIGN" />
        </a>

        <button
          className={`nav-toggle${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>

        <div className={`nav-links${menuOpen ? " open" : ""}`}>
          <a href="/" onClick={closeMenu}>Apps</a>
          <a href="#contact" onClick={openContact}>Contacto</a>
        </div>
      </nav>

      {/* ── Main Content (solo el swiper) ── */}
      <div className="content">
        <Home />
      </div>

      {/* ── Contacto Overlay ── */}
      <div
        className={`contact-overlay${contactOpen ? " open" : ""}`}
        onClick={() => setContactOpen(false)}
      >
        <div className="contact-panel" onClick={(e) => e.stopPropagation()}>
          <button
            className="contact-panel-close"
            onClick={() => setContactOpen(false)}
            aria-label="Cerrar"
          >
            ✕
          </button>
          <Contact />
        </div>
      </div>

      {/* ── Footer ── */}
      <footer className="footer">
        <div className="footer-brand">
          <img src="/imagenes/logo.png" alt="Logo" />
          <span>APP DGM DESIGN</span>
        </div>
        <div className="footer-line" />
        <p>
          &copy; {new Date().getFullYear()} APP DGM DESIGN — Todos los derechos reservados
          &nbsp;·&nbsp;
          <a href="mailto:appdgmdesign@gmail.com">appdgmdesign@gmail.com</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
